if(!customElements.get("carousel-component")) {
    class Carousel extends HTMLElement {
      constructor() {
        super();
        this.carouselElement = this;
    
        this.desktopPerPage = this.carouselElement.dataset['desktopperpage'] || 4;
        this.mobilePerPage = this.carouselElement.dataset['mobileperpage'] || 1;
        this.focus = this.carouselElement.dataset['focus'] || "left";
        this.type = this.carouselElement.dataset['type'];
        this.gap = this.carouselElement.dataset['gapbetweenslides'] || 0;
        this.gapMobile = this.carouselElement.dataset['gapbetweenslidesonmobile'] || 0;
        this.autoplaySpeed = parseInt(this.dataset['autoplaySpeed']) || 3000;
        this.direction = this.carouselElement.dataset['direction'] || 'ltr';
        this.mobilePaddingLeft = this.carouselElement.dataset['mobilepaddingleft'] || '0';
        this.mobilePaddingRight = this.carouselElement.dataset['mobilepaddingright'] || '0';
        this.desktopPaddingLeft = this.carouselElement.dataset['desktoppaddingleft'] || '0';
        this.desktopPaddingRight = this.carouselElement.dataset['desktoppaddingright'] || '0';
        this.showarrows = this.carouselElement.dataset['showarrows'] === 'true' || false;
        this.autoplay = this.carouselElement.dataset['autoplay'] === 'true' || false;
        this.showarrowsonmobile = this.carouselElement.dataset['showarrowsonmobile'] === 'true' || false;
        this.showdots = this.carouselElement.dataset['showdots'] === 'true' || false;
        this.showdotsonmobile = this.carouselElement.dataset['showdotsonmobile'] === 'true' || false;
        this.isNavigation = this.carouselElement.dataset['isnavigation'] === 'true' || false;
        this.disableDrag = this.carouselElement.dataset['disabledrag'] === 'true' || false;
        this.disableDragMobile = this.carouselElement.dataset['disabledragmobile'] === 'true' || false;
        this.destroyOnMobile = this.carouselElement.dataset['enableonmobile'] == 'false' || false;
        this.destroyOnDesktop = this.carouselElement.dataset['enableondesktop'] == 'false' || false;
        this.omitEnd = this.carouselElement.dataset['omitEnd'] == 'false' || false;
        this.rewind = this.carouselElement.dataset['rewind'] == 'true' || false;
        this.refresh = this.carouselElement.dataset['refresh'] == 'true' || false;
        this.sync = this.carouselElement.dataset['carouselsyncselector'] || false;
        this.centerFocus = this.carouselElement.dataset['centerfocus'] || false;
        this.perMove = this.carouselElement.dataset['permove'] || 1;
        this.perMoveMobile = this.carouselElement.dataset['permovemobile'] || 1;
        this.omitMobileEnd = this.carouselElement.dataset['omitMobileEnd'] == 'false' || false;
        this.Mobilefocus = this.carouselElement.dataset['mobilefocus'];
        
  
        // Carousel element should have class splide
        if (!this.carouselElement.classList.contains('splide')) return;
    
        this.initCarousel();
      }
     
      initCarousel() {
        if (this.destroyOnMobile && this.destroyOnDesktop) return;
        // More option available here https://splidejs.com/documents/
        // This slider can be customized as require check the above doc before adding any new 
        // Slider library.
        this.carousel = new Splide(this.carouselElement, {
          perPage: this.desktopPerPage,
          ...(this.type ? { type: this.type } : {}),
          ...(this.focus ? { focus: this.focus } : {}),
          autoplay: this.autoplay,
          interval: this.autoplaySpeed,
          gap: this.gap,
          arrows: this.showarrows,
          pagination: this.showdots,
          isNavigation: this.isNavigation,
          drag: !this.disableDrag,
          direction: this.direction,
          destroy: this.destroyOnDesktop,
          padding: { left: this.desktopPaddingLeft, right: this.desktopPaddingRight },
          omitEnd : this.omitEnd,
          rewind:this.rewind,
          perMove:this.perMove,
          rewindByDrag:this.rewind,
          rewindSpeed:this.rewind,
          updateOnMove:true,
          ...(this.direction === 'ttb' && {
            height: this.carouselElement.dataset['height'] || '620px',
            autoHeight: true,
          }),
          breakpoints: {
            750: {
              padding: { left: this.mobilePaddingLeft, right: this.mobilePaddingRight },
              perPage: this.mobilePerPage,
              arrows: this.showarrowsonmobile,
              pagination: this.showdotsonmobile,
              gap: this.gapMobile,
              perMove: this.perMoveMobile,
              destroy: this.destroyOnMobile,
              drag: !this.disableDragMobile,
              updateOnMove:true,
              omitEnd : this.omitMobileEnd,
              ...(this.Mobilefocus ? { focus: this.Mobilefocus } : {}),
              ...(this.direction === 'ttb' && {
                height: this.carouselElement.dataset['height'] || '610px',
                direction: 'ttb',
              }),

            }
          },
        });
    
        if (this.sync) {
          this.initCarouselSync()
        } else {
          this.initProgressBar(this.carousel);
          this.carousel.mount();
  
          if (this.carousel)
            this.carousel.refresh()
        }
      }
  
      // progress bar starting
     initProgressBar(skeletonSplide) {
      const scrollbar = this.querySelector('#customScrollbar');
      const thumb = this.querySelector('#scrollbarThumb');
      
      if (!scrollbar || !thumb) return;
      
      skeletonSplide.on('mounted move', () => {
        const totalSlides = skeletonSplide.length;
        const slidesPerPage = skeletonSplide.options.perPage;
      
        const thumbWidth = (slidesPerPage / totalSlides) * 100;
        const activeIndex = skeletonSplide.index;
        const thumbPosition = (activeIndex / (totalSlides - slidesPerPage)) * (100 - thumbWidth);
      
        thumb.style.width = `${thumbWidth}%`;
        thumb.style.left = `${Math.max(0, thumbPosition)}%`;
      });
      
      let isDragging = false;
      let startX;
      
      const onMouseMove = (e) => {
        if (!isDragging) return;
        const deltaX = e.clientX - startX;
        const scrollbarWidth = scrollbar.offsetWidth;
        const thumbWidth = thumb.offsetWidth;
        let left = (parseFloat(thumb.style.left || 0) * scrollbarWidth) / 100 + deltaX;
        left = Math.max(0, Math.min(scrollbarWidth - thumbWidth, left));
        thumb.style.left = `${(left / scrollbarWidth) * 100}%`;
        startX = e.clientX;
        const totalSlides = skeletonSplide.length;
        const slidesPerPage = skeletonSplide.options.perPage;
        const maxLeft = scrollbarWidth - thumbWidth;
        const percentage = left / maxLeft;
        const index = Math.round(percentage * (totalSlides - slidesPerPage));
        skeletonSplide.go(index);
      };
      
      const onMouseUp = () => {
        isDragging = false;
        document.removeEventListener('mousemove', onMouseMove);
        document.removeEventListener('mouseup', onMouseUp);
        document.body.style.cursor = '';
      };
      
      const onTouchMove = (e) => {
        if (!isDragging) return;
        const deltaX = e.touches[0].clientX - startX;
        const scrollbarWidth = scrollbar.offsetWidth;
        const thumbWidth = thumb.offsetWidth;
        let left = (parseFloat(thumb.style.left || 0) * scrollbarWidth) / 100 + deltaX;
        left = Math.max(0, Math.min(scrollbarWidth - thumbWidth, left));
        thumb.style.left = `${(left / scrollbarWidth) * 100}%`;
        startX = e.touches[0].clientX;
        const totalSlides = skeletonSplide.length;
        const slidesPerPage = skeletonSplide.options.perPage;
        const maxLeft = scrollbarWidth - thumbWidth;
        const percentage = left / maxLeft;
        const index = Math.round(percentage * (totalSlides - slidesPerPage));
        skeletonSplide.go(index);
      };
      
      const onTouchEnd = () => {
        isDragging = false;
        document.removeEventListener('touchmove', onTouchMove);
        document.removeEventListener('touchend', onTouchEnd);
      };
      
      thumb.addEventListener('mousedown', (e) => {
        isDragging = true;
        startX = e.clientX;
        e.preventDefault();
        document.addEventListener('mousemove', onMouseMove);
        document.addEventListener('mouseup', onMouseUp);
        document.body.style.cursor = 'grabbing';
      });
      
      thumb.addEventListener('touchstart', (e) => {
        isDragging = true;
        startX = e.touches[0].clientX;
        e.preventDefault();
        document.addEventListener('touchmove', onTouchMove);
        document.addEventListener('touchend', onTouchEnd);
      })
    }
    // progress bar ending


      initCarouselSync() {
        this.syncElement = document.querySelector(this.sync);
        this.direction = this.syncElement.dataset['direction'] || 'ltr'
    
        this.carouselSync = new Splide(this.sync, {
          updateOnMove: true,
          perPage: this.syncElement.dataset['desktopperpage'] || 5,
          type: this.syncElement.dataset['type'] || 'loop',
          focus: this.syncElement.dataset['focus'] || 'center',
          isNavigation: this.syncElement.dataset['isnavigation'] === 'true' || false,
          pagination: false,
          arrows: this.syncElement.dataset['showarrows'] === 'true' || false,
          drag: true,
          // Conditional configuration for 'ttb' direction
          ...(this.direction === 'ttb' && {
            height: this.getPrimarySlideFirstImageHeight(),
            direction: 'ttb',
            autoHeight: true,
          }),
          breakpoints: {
            767: {
              height: 'auto',
              direction: 'ltr',
              gap: this.gapMobile,
              focus:this.Mobilefocus
                        }
          },
        });
        
    
        this.carousel.sync(this.carouselSync);
        this.carousel.mount();
        this.carouselSync.mount();
      };
    
      refreshSlider() {
        this.carousel.refresh();
        if (this.carouselSync) {
          this.carouselSync.refresh();
        }
      }
  
      getPrimarySlideFirstImageHeight() {
        const image = this.querySelector('.splide__list img');
        const containerWidth = this.querySelector('.splide__list').clientWidth;
    
        // Get the original width and height of the image
        const originalWidth = image.getAttribute('width');
        const originalHeight = image.getAttribute('height');
    
        // Calculate the scaled height to fit within the container
        return (containerWidth / originalWidth) * originalHeight;
      }
    }
  
    // Exposing the Carousel class globally to allow other custom elements, like the product-form, to extend its functionality.
    window.Carousel = Carousel;
    customElements.define('carousel-component', Carousel);
  }